<template>
  <router-view />
</template>

<script>
export default {
  name: 'App',
};
</script>



// WEBPACK FOOTER //
// App.vue?2d1054a6